export default "__VITE_ASSET__B$egKQzW__"